export const youtube_parse_video_id_from_url = url => {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  const match = url.match(regExp)
  return match && match[7].length === 11 ? match[7] : false
}

export const youtube_fetch_thumbnail_from_video_id = videoId =>
  `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`

export const youtube_parse_time_from_url = url => {
  // taken from https://stackoverflow.com/questions/16050460/regex-to-return-start-time-t-from-youtube-url
  // minor change '#' => '&' before t
  const myRegexp = /youtube.com\S+&t=((\d+m)?(\d+[s]?)?)/g
  const match = myRegexp.exec(url)
  if (match) {
    return match[1]
  }
  return "0"
}
